<template>
  <QStepper
    :class="[
      'SAI-stepper bg-transparent q-pa-none',
      vertical ? 'SAI-stepper--vertical' : 'SAI-stepper--horizontal'
    ]"
    :value="value"
    :steps="steps"
    :flat="flat"
    vertical
    v-bind="$attrs"
    v-on="$listeners"
  >
    <QStep
      v-for="(step, index) in displaySteps"
      :class="{
        'SAI-step--historic': step.historic,
        'SAI-step--historic-right-normal': historicThenNormal(index)
      }"
      :color="step.historic ? 'primary-semi-dark' : 'primary-semi-light'"
      :done-color="step.historic ? 'primary-semi-dark' : 'white'"
      :active-color="step.historic ? 'primary-semi-dark' : 'white'"
      :key="index"
      :done="step.done || step.historic"
      :active-icon="step.done ? 'eva-checkmark' : step.icon"
      v-bind="step"
    >
      <slot :name="step.slotName" />
    </QStep>
  </QStepper>
</template>

<script>
import { QStepper, QStep } from 'quasar';

export default {
  name: 'SAIOrderStepper',
  props: {
    value: undefined,
    /**
     * Model: {
     *  ...QStepProps,
     *  historic: Boolean
     * }
     */
    steps: {
      type: Array,
      default: () => []
    },
    showHistory: Boolean,
    vertical: Boolean,
    animated: {
      type: Boolean,
      default: true
    },
    flat: {
      type: Boolean,
      default: true
    },
    isMobile: Boolean
  },
  computed: {
    displaySteps() {
      if (this.showHistory) {
        return this.steps;
      }
      return this.steps.filter((step) => !step.historic);
    }
  },
  methods: {
    historicThenNormal(index) {
      if (
        !this.steps ||
        !this.steps[index + 1] ||
        !this.steps[index].historic
      ) {
        return false;
      }
      return !this.steps[index + 1].historic;
    }
  },
  components: {
    QStepper,
    QStep
  }
};
</script>

<style lang="sass" scoped>
.SAI-stepper::v-deep
  .q-stepper__step
    display: flex
    align-items: flex-start

  .q-stepper__tab
    display: inline-flex

  .q-stepper__label
    color: white

  .q-stepper__dot
    margin: 0 8px 0 0
    width: 48px
    height: 48px
    font-size: 24px

  .q-stepper__tab
    padding: 0

  .q-stepper__step-inner
    padding: 0

  .q-stepper__tab--done,
  .q-stepper__tab--active
    .q-stepper__dot .row .q-icon
      color: $primary

  .SAI-step--historic
    .q-stepper__dot .row .q-icon
      color: white

  // Make the done dots smaller if not active
  .q-stepper__tab--done:not(.q-stepper__tab--active),
    .q-stepper__dot
      margin: 0 8px
      width: 32px
      height: 32px
      font-size: 16px

    .q-stepper__title
      font-weight: bold
      opacity: 0.8

  .q-stepper__tab--active
    flex-grow: 0

    .q-stepper__label
      display: none

  .SAI-step--historic
    .q-stepper__dot:after,
    .q-stepper__dot:before
      border-color: currentColor !important

  .SAI-step--historic-right-normal
    .q-stepper__dot:after
      border-color: white !important

  .q-stepper__caption
    font-size: 12px

  &.SAI-stepper--vertical
    .q-stepper__step
      padding: 12px 0

      &:first-of-type
        padding-top: 0

      &:last-of-type
        padding-bottom: 0

    .q-stepper__dot
      &:before,
      &:after
        width: 0
        border-left: 2px dashed white

      &:before
        margin-bottom: 0

      &:after
        margin-top: 0

  &.SAI-stepper--horizontal
    .q-stepper__dot
      margin: 0 0 8px 0

    .q-stepper__content
      display: flex
      overflow: auto
      flex-wrap: nowrap

    .q-stepper__step
      padding: 0 12px
      flex-direction: column
      align-items: center
      flex-grow: 1
      flex-shrink: 0

      &:first-of-type
        padding-left: 0

      &:last-of-type
        padding-right: 0

    .q-stepper__tab
      flex-direction: column

    .q-stepper__label
      text-align: center

    .q-stepper__caption
      margin-top: 4px

    .q-stepper__dot
      &:before,
      &:after
        height: 0
        top: 50%
        width: 999999px
        border-top: 2px dashed white

      &:before
        right: 100%
        left: initial
        margin-bottom: 0

      &:after
        left: 100%
        right: initial
        margin-top: 0

    .q-stepper__tab--done:not(.q-stepper__tab--active),
      .q-stepper__dot
        margin: 8px 0 16px
</style>
